import * as React from "react";
import type { SVGProps } from "react";
const SvgImageAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m4.903 22.097 10.2-9.6 4.8 4.8m-15 4.8h12a3.6 3.6 0 0 0 3.6-3.6v-6m-15.6 9.6a3.6 3.6 0 0 1-3.6-3.6v-12a3.6 3.6 0 0 1 3.6-3.6h7.8m6.6 5.794V5.297m0 0V1.903m0 3.394h-3.394m3.394 0h3.394m-14.194 3a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0"
    />
  </svg>
);
export default SvgImageAdd;
